import {Component, ElementRef, EventEmitter, Input, Output, Renderer2} from '@angular/core';
import {CONFIG} from '../../app/config';
import {Platform} from 'ionic-angular';

@Component({
    selector: 'backfull',
    templateUrl: 'backfull.html',
    host: {'(window:resize)': 'onWindowResize(true)'}
})
export class Backfull {

    private config: any;

    private element: HTMLElement;
    private renderTO: number;

    private divs: HTMLElement[] = [];

    @Input('adjust-height')  private adjustHeight = false;

    /** COLOR **/
    @Input('color-corone')   private colorCorone: string;
    @Input('color-cortwo')   private colorCortwo: string;


    /** VIDEO **/
    @Input('video-scroll')   public  videoScroll: 'Scroll' | 'Fixed' = 'Scroll'; //#tslint - Nao esta usando entao coloquei "public"
    @Input('video-source')   private videoSource: string; //#Symbol
    @Input('video-opacit')   public  videoOpacit: number = 0.1;                  //#tslint - Nao esta usando entao coloquei "public"
    @Input('video-grayed')   private videoGrayed: boolean;
    @Input('video-adjust')   private videoAdjust: boolean;


    /** IMAGE **/
    @Input('image-scroll')   private imageScroll: 'Scroll' | 'Fixed' | 'SCover' | 'FCover' | 'Left' | 'Right' | 'Repeat' | 'Mixed' = 'Scroll';
    @Input('image-source')   private imageSource: string;
    @Input('image-opacit')   private imageOpacit: number = 0.1;
    @Input('image-grayed')   private imageGrayed: boolean;
    @Input('image-adjust')   private imageAdjust: boolean;
    @Input('image-sizeed')   private imageSizeed: number;

    @Input('mixed-scroll')   public  mixedScroll: 'knit' = 'knit';              //#tslint - Nao esta usando entao coloquei "public"
    @Input('mixed-spaced')   private mixedSpaced: number = 30;
    @Input('mixed-sizeed')   private mixedSizeed: number = 0.4;
    @Input('mixed-random')   private mixedRandom: number = 0.1;


    /** AMIGO **/
    @Input('amigo-arrayd')   private amigoArrayd: any;
    @Input('amigo-opacit')   private amigoOpacit: number = 40;


    /** ATUAL **/
    @Input('onlypc') private onlypc: boolean;

    @Output('on-init') onInit: any = new EventEmitter();

    constructor(element: ElementRef, public renderer: Renderer2, public platform: Platform) {

        this.config = CONFIG;

        this.element = element.nativeElement;

    }

    ngAfterViewInit() {

        this.onInit.emit({
            backRender: () => {
                return this.onWindowResize(false)
            }
        });

        const backshow = (!this.onlypc || window.innerWidth > 700);

        if (this.videoSource && backshow) {

            let mime = null;

            if (this.videoSource.substr(-3) === 'mp4') mime = 'video/mp4';
            if (this.videoSource.substr(-3) === 'ogg') mime = 'video/ogg';
            if (this.videoSource.substr(-3) === 'ogv') mime = 'video/ogg';

            if (!mime) return;

            let tagVideo = this.renderer.createElement('video');
            tagVideo.setAttribute('src', this.videoSource);
            tagVideo.setAttribute('type', mime);
            tagVideo.setAttribute('autoplay', '');
            tagVideo.setAttribute('muted', '');
            tagVideo.setAttribute('loop', '');
            tagVideo.setAttribute('playsinline', '');
            tagVideo.setAttribute('webkit-playsinline', '');
            tagVideo.setAttribute('class', 'action-video');

            tagVideo.volume = 0;

            if (this.videoGrayed) this.renderer.addClass(tagVideo, 'filter-gray');

            this.element.appendChild(tagVideo);

        }

        if (this.amigoArrayd && backshow) {

            ['L', 'R'].forEach(lado => {

                this.amigoArrayd.forEach((amigo, index) => {

                    let tagImage = this.renderer.createElement('img');
                    tagImage.setAttribute('class', 'position-absolute friendly-low-res');
                    tagImage.setAttribute('src', amigo.ProfileFace);

                    let friendlyBgPos = this.friendlyBgPos(lado, index);

                    for (let key in friendlyBgPos) {
                        if (!friendlyBgPos.hasOwnProperty(key)) continue;
                        this.renderer.setStyle(tagImage, key, friendlyBgPos[key]);
                    }

                    if (this.imageGrayed) this.renderer.addClass(tagImage, 'filter-gray');

                    this.element.appendChild(tagImage);

                });

            });

        }

        if (this.config.colors[this.colorCorone] && this.config.colors[this.colorCortwo]) {
            this.element.style.setProperty(
                'background-image',
                'linear-gradient(to bottom, ' + this.config.colors[this.colorCorone] + ', ' + this.config.colors[this.colorCortwo] + ')');
        }

        setTimeout(() => {

            //Altura do tamanho do conteudo
            if (this.adjustHeight) {
                this.setHeight();
            }

            switch(this.imageScroll) {

                case 'Scroll':
                case 'Fixed':
                case 'SCover':
                case 'FCover':
                case 'Left':
                case 'Right':
                case 'Repeat':
                    this.renderOther();
                    break;

                case 'Mixed':

                    for (let key in this.element.children) {
                        if (!(parseInt(key, 10) >= 0)) continue;
                        this.renderer.addClass(this.element.children[key], 'position-relative');
                    }

                    this.renderMixed(0);
                    break;

            }

        }, 300);

    }

    onWindowResize(boolout: boolean) {

        this.renderMixed((boolout ? 300 : 0));

    }

    setHeight(height: number = 0) {

        if (this.element.parentElement.style.height) { // caso setou manualmente (action window.innerHeight)
            this.element.style.setProperty('height', this.element.parentElement.style.height); // pega o que setou na mão
            return;
        }

        if (!height) { // se não vier de image ou video adjust, pega o height automático
            this.element.style.setProperty('height', this.element.parentElement.offsetHeight + 'px');
            return;
        }

        this.element.parentElement.style.setProperty('height', height + 'px');
        this.element.style.setProperty('height', height + 'px');

    }

    renderOther() {

        const backshow = (!this.onlypc || window.innerWidth > 700);

        if (!backshow || !this.imageSource) return;

        let wx: string = this.imageSizeed ? this.imageSizeed + 'px' : 'auto',
            wy: string = this.imageSizeed ? this.imageSizeed + 'px' : 'auto';

        this.element.style.setProperty('--backfullSRC', 'url(' + this.imageSource + ')');
        this.element.style.setProperty('--backfullWX', wx);
        this.element.style.setProperty('--backfullWY', wy);

        this.renderer.addClass(this.element, 'backfull');

        if (this.imageScroll == 'Fixed')  this.renderer.addClass(this.element, 'bf-fixed');
        if (this.imageScroll == 'Fixed' && this.platform.is('ios'))  this.renderer.addClass(this.element, 'bf-fixed-ios');
        if (this.imageScroll == 'SCover') this.renderer.addClass(this.element, 'bf-scover');
        if (this.imageScroll == 'FCover') this.renderer.addClass(this.element, 'bf-fcover');
        if (this.imageScroll == 'FCover' && this.platform.is('ios')) this.renderer.addClass(this.element, 'bf-fcover-ios');
        if (this.imageScroll == 'Left')   this.renderer.addClass(this.element, 'bf-left');
        if (this.imageScroll == 'Right')  this.renderer.addClass(this.element, 'bf-right');
        if (this.imageScroll == 'Repeat') this.renderer.addClass(this.element, 'bf-repeat');

        if (this.imageGrayed)             this.renderer.addClass(this.element, 'bf-filter-gray');

        this.renderer.addClass(this.element, 'opct-' + Math.round(this.imageOpacit * 10));

        setTimeout(() => {

            //Altura do tamanho do video
            if (this.videoAdjust) {
                const vdo = document.createElement('video');
                vdo.src = this.imageSource;
                vdo.onload = (event) => this.setHeight(vdo.height);
                return;
            }

            //Altura do tamanho da imagem
            if (this.imageAdjust) {
                const img = new Image;
                img.src = this.imageSource;
                img.onload = (event) => this.setHeight(img.height);
                return;
            }

        });

    }

    renderMixed(timeout: number = 0) {

        const backshow = (!this.onlypc || window.innerWidth > 700);

        if (!this.imageSource || this.imageScroll !== 'Mixed' || !backshow) return;

        this.imageSizeed = this.imageSizeed ? this.imageSizeed : 200;

        this.renderTO && clearTimeout(this.renderTO);
        this.renderTO = setTimeout(() => {

            if (this.divs.length) {
                this.divs.forEach(div => {
                    this.renderer.removeChild(this.element, div);
                });
                this.divs = [];
            }

            if (typeof this.imageOpacit == 'string') this.imageOpacit = parseFloat(this.imageOpacit);
            if (typeof this.imageGrayed == 'string') this.imageGrayed = (this.imageGrayed == 'true');
            if (typeof this.imageSizeed == 'string') this.imageSizeed = parseInt(this.imageSizeed, 10);
            if (typeof this.mixedSpaced == 'string') this.mixedSpaced = parseInt(this.mixedSpaced, 10);
            if (typeof this.mixedSizeed == 'string') this.mixedSizeed = parseFloat(this.mixedSizeed);
            if (typeof this.mixedRandom == 'string') this.mixedRandom = parseFloat(this.mixedRandom);

            let sizeSmall: number = this.imageSizeed * 0.4;
            let sizeHeight: number = this.imageSizeed + this.mixedSpaced;
            let sizeWidth: number = (this.imageSizeed + sizeSmall + (this.mixedSpaced * 2)) / 2;

            let colus: number = Math.ceil(this.element.offsetWidth  / sizeWidth);   // COLUNA..: altura da grande
            let lines: number = Math.ceil(this.element.offsetHeight / sizeHeight);  // LINHA...: média da grande e da pequena

            let top: number = 0;
            let left: number = 0;

            this.renderer.addClass(this.element, 'position-relative');
            this.renderer.setStyle(this.element, 'overflow', 'hidden');
            //this.renderer.setStyle(this.element, 'z-index', '1');

            for (let lin = 1; lin <= lines; lin++) {

                top = sizeHeight * (lin - 1);

                for (let col = 1; col <= colus; col++) {

                    let tipoImg = (col % 2) ? 'G' : 'P';

                    // linhas pares / começa no 1
                    if (!(lin % 2)) tipoImg = (tipoImg == 'G' ? 'P' : 'G');

                    let tamanho: number = (tipoImg == 'G' ? this.imageSizeed : sizeSmall);

                    // randomizar tamanho para mais ou para menos
                    let tamanhoDif = tamanho * this.mixedSizeed * Math.random() * (Math.random() > 0.5 ? 1 : -1);

                    tamanho += tamanhoDif;

                    let topOk: number = top + (tamanhoDif / 2 * -1) + (tipoImg == 'P' ? ((this.imageSizeed / 2) - (tamanho / 2)) : 0);
                    //let topOk: number = top;

                    topOk += topOk * this.mixedRandom * Math.random() * (Math.random() > 0.5 ? 1 : -1);

                    let child: any;
                    this.divs.push(child = document.createElement('div'));
                    // this.renderer.appendChild(this.element, child);
                    this.element.insertAdjacentElement('afterbegin', child);

                    //child.innerHTML = topOk;

                    this.renderer.addClass(child, 'display-block');
                    this.renderer.addClass(child, 'position-absolute');

                    if (this.imageGrayed) this.renderer.addClass(child, 'filter-gray');

                    this.renderer.setStyle(child, 'background', 'transparent url(' + this.imageSource + ') no-repeat scroll 0 0 / ' + tamanho + 'px ' + tamanho + 'px');
                    this.renderer.setStyle(child, 'opacity', this.imageOpacit);
                    this.renderer.setStyle(child, 'height', tamanho + 'px');
                    this.renderer.setStyle(child, 'width', tamanho + 'px');
                    this.renderer.setStyle(child, 'top', topOk + 'px');
                    this.renderer.setStyle(child, 'left', left + 'px');
                    //this.renderer.setStyle(child, 'z-index', '-1');

                    left += tamanho + this.mixedSpaced;

                }

                left = 0;

            }

        }, timeout);

    }

    friendlyBgPos(lado, index): any {

        const mapa = [{top: '15px',  side: '80px',  width: '180px'},
                      {top: '65px',  side: '280px', width: '100px'},
                      {top: '190px', side: '200px', width: '115px'},
                      {top: '220px', side: '50px',  width: '130px'},
                      {top: '100px', side: '-70px', width: '145px'},
                      {top: '-90px', side: '-70px', width: '160px'}];

        const line = mapa[index];
        if (!line) return {display: 'none'};

        let ngStyle: any = {'border-radius': '50%', opacity: (this.amigoOpacit / 100)};
        if (lado == 'L') ngStyle = {top: line.top, left: line.side, width: line.width, ...ngStyle};
        if (lado == 'R') ngStyle = {top: line.top, right: line.side, width: line.width, ...ngStyle};

        return ngStyle;

    }

}



// WEBPACK FOOTER //
// ./src/components/backfull/backfull.ts